export default function getContentStateCharacterCount(contentState) {
  return contentState
    ? contentState
        .getBlockMap()
        .filter(block => block.getType() !== 'atomic')
        .reduce((count, block) => block.getText().length + count, 0)
    : 0;
}
